import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/features/auth/stores/auth-context';
import { DataCacheProvider } from '@/store/data-cache-context';
import { OrgProvider } from '@/store/org-context';
import { useAuth } from '@/features/auth/hooks/use-auth';
import { ToastProvider } from '@/components/ui/toast';
import { useKeyboardDismissNudge } from '@/lib/use-keyboard-dismiss-nudge';

function GlobalEffects() {
  useKeyboardDismissNudge();
  return null;
}

function OrgProviderBridge({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const ownOrgId = user?.organizationId ?? '';
  const ownOrgName = ''; // resolved lazily; banner/switcher use the org API

  return (
    <OrgProvider ownOrgId={ownOrgId} ownOrgName={ownOrgName}>
      {children}
    </OrgProvider>
  );
}

interface AppProviderProps {
  children: React.ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <BrowserRouter>
      <ToastProvider>
        <DataCacheProvider>
          <AuthProvider>
            <OrgProviderBridge>
              <GlobalEffects />
              {children}
            </OrgProviderBridge>
          </AuthProvider>
        </DataCacheProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
